import DialogContent from '@zenbusiness/zui/DialogContent';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';


export const DialogContentStyle = ({ theme }) => ({
  padding: '40px 0 100px 0',
  backgroundColor: theme.palette.background.grey.main,
  [theme.breakpoints.up('md')]: {
    padding: '60px 0 100px 0'
  }
});

export const FieldContainerStyle = ({ theme }) => ({
  padding: '16px 24px',
  borderRadius: '16px',
  border: `1px solid ${theme.palette.border.main}`,
  backgroundColor: theme.palette.background.grey.light
});

export const WrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
});

export const DialogContentStyled = styled(DialogContent)(DialogContentStyle);
export const FieldContainerStyled = styled('div')(FieldContainerStyle);
export const Wrapper = styled(Stack)(WrapperStyle);
